import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import CommonAttachments from 'common/components/entities/Attachments'
import React from 'react'
import { AttachmentsInterface } from 'src/shared/types/entities/attachments-interface'
import { EntityProps } from '../../../types'
import { useContactUsDescendantIds } from './ContactUs'

export default function Attachments({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<AttachmentsInterface>) {
  const entityIds = useContactUsDescendantIds()

  if (!entity.show) {
    return <div />
  }

  return (
    <>
      <BaseEntityNew
        entity={entity}
        isMoveDownAllowed={isMoveDownAllowed}
        isMoveUpAllowed={isMoveUpAllowed}
        isRemoveAllowed={false}
        isSaveAllowed={false}
        isCopyAllowed={false}
        dropBoxAllowedEntityIds={entityIds}
        flex
        flexColumn
      >
        <CommonAttachments
          padding={entity.padding}
          mobilePadding={entity.mobilePadding}
          alignSelf={entity.alignSelf}
          mobileAlignSelf={entity.mobileAlignSelf}
          backgroundColor={entity.backgroundColor}
          mobileBackgroundColor={entity.mobileBackgroundColor}
          attrId={entity.htmlAttrId}
          color={entity.color}
          fontSize={entity.fontSize}
          mobileColor={entity.mobileColor}
          mobileFontSize={entity.mobileFontSize}
          fontFamily={entity.fontFamily}
          fontWeight={entity.fontWeight}
          fontStyle={entity.fontStyle}
          mobileFontFamily={entity.mobileFontFamily}
          mobileFontWeight={entity.mobileFontWeight}
          mobileFontStyle={entity.mobileFontStyle}
          iconClassName={entity.iconClassName}
          boxShadow={entity.boxShadow}
          mobileBoxShadow={entity.mobileBoxShadow}
          border={entity.border}
          mobileBorder={entity.mobileBorder}
          disabled
        />
      </BaseEntityNew>
    </>
  )
}
